
import { mapState, mapActions } from 'vuex';
import HttpStatus from '@/enums/HttpStatus';

export default {
  name: 'ReviewPasswordDialog',
  data() {
    return {
      isSubmitting: false,
      passwordStatus: 'unchecked'
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('window', ['windowService']),
    ...mapState('form', ['formValues']),
    reviewId() {
      return this.$route.params.review_id;
    },
    mode() {
      return this.$route.query.mode === 'edit' ? 'edit' : 'delete';
    },
    isSubmitDisabled() {
      return (
        this.formValues.password === '' || this.passwordStatus === 'invalid'
      );
    },
    fields() {
      return [
        {
          key: 'password',
          type: 'password',
          inputProps: {
            autocomplete: 'off',
            placeholder: this.$t('password.placeholder')
          },
          validators: [
            {
              rule: () => this.passwordStatus !== 'invalid',
              message: this.$t('password.invalid')
            }
          ]
        }
      ];
    }
  },
  watch: {
    'formValues.password'() {
      this.setPasswordStatus('unchecked');
    }
  },
  created() {
    this.setFormValues({ password: '' });
    this.setValidationRules({
      password: {
        validity: () =>
          this.passwordStatus !== 'invalid' || this.$t('password.invalid')
      }
    });
  },
  methods: {
    ...mapActions('form', [
      'setFormValues',
      'setValidationRules',
      'validateField'
    ]),
    setPasswordStatus(passwordStatus) {
      if (this.passwordStatus === passwordStatus) return;

      this.passwordStatus = passwordStatus;
      this.validateField('password');
    },
    onSubmit() {
      if (this.isSubmitDisabled) return;

      this.isSubmitting = true;
      this.api
        .checkReviewPassword(this.reviewId, this.formValues.password)
        .then(() => {
          this.setPasswordStatus('valid');
          this.windowService.closeFullscreenPopup(this.formValues.password);
        })
        .catch(error => {
          if (error.response.status === HttpStatus.UNAUTHORIZED)
            this.setPasswordStatus('invalid');
          else throw error;
        })
        .finally(() => (this.isSubmitting = false));
    },
    onClose() {
      this.windowService.closeFullscreenPopup();
    }
  }
};
